<div class="container">
  <main role="main" class="form-signin w-100 m-auto text-center">
    <h1>Error</h1>
    <p>
      {{ message }}
    </p>
  </main>
</div>
